const userDetailsFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  company: '',
  country: '',

  readOnlyEmail: true
};

export default userDetailsFormValues;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/UserDetails/userDetailsFormValues.js